import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
// import { useNavigate } from "react-router-dom";

import configData from "./config.json";

export const Auth0Wrapper = ({ children }) => {
    // const navigate = useNavigate();

    console.log(configData)

    // allow an explicit redirect URI via env to support HTTPS dev servers
    const redirectUri =
        process.env.REACT_APP_AUTH0_REDIRECT_URI ||
        window.location.origin; // origin will be https://localhost:3000 when HTTPS=true

    return (
        <Auth0Provider
            clientId={configData.auth0ClientId}
            domain={configData.auth0Domain}
            audience={configData.auth0Audience}
            redirectUri={redirectUri}
            useRefreshTokens
            cacheLocation="localstorage"
        >
            {children}
        </Auth0Provider>
    );
};